// import api from '@/api'

const state = {
  token: localStorage.token,
  userInfo: localStorage.userInfo,
  perms: [],
  menuRouteLoaded: false, // 菜单和路由是否已经加载
  navTree: [], // 导航菜单树
  buttonRoles: []
}

const getters = {
  isLogin: (state) => {
    return state.token
  },
  userInfo: (state) => {
    return state.userInfo
  },
  navTree: (state) => {
    return state.navTree
  },
  buttonRoles: (state) => {
    return state.navTree
  }
}

const actions = {
  login(context, payload) {
    return new Promise((resolve) => {
      // 登录成功，写入 token 信息
      context.commit('setData', {
        token: payload.token,
        userInfo: payload
      })
      resolve()
    })
  },
  update(context, payload) {
    return new Promise((resolve) => {
      // 登录成功，写入 token 信息
      context.commit('setData', {
        token: state.token,
        userInfo: payload
      })
      resolve()
    })
  },
  logout(context) {
    context.commit('delData')
  },
  setPerms(state, perms) {
    // 用户权限标识集合
    state.perms = perms
  },
  setNavTree(context, payload) {
    return new Promise((resolve) => {
      // 登录成功，写入 token 信息
      context.commit('NAV_TREE', payload)
      resolve()
    })
  },
  setMenuRouteLoaded(context, status) {
    return new Promise((resolve) => {
      // 登录成功，写入 token 信息
      context.commit('MENU_ROUTER_LOADED', status)
      resolve()
    })
  },
  setButtonRoles(context, payload) {
    return new Promise((resolve) => {
      context.commit('BUTTON_ROLES', payload)
      resolve()
    })
  }
}

const mutations = {
  setData(state, data) {
    localStorage.setItem('token', data.token)
    localStorage.setItem('userInfo', JSON.stringify(data.userInfo))
    state.token = data.token
    state.userInfo = JSON.stringify(data.userInfo)
  },
  delData() {
    state.token = null
    state.userInfo = null
    state.navTree = []
    state.menuRouteLoaded = false
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  },
  MENU_ROUTER_LOADED(state, status) {
    state.menuRouteLoaded = status
  },
  NAV_TREE(state, data) {
    state.navTree = data
  },
  BUTTON_ROLES(state, status) {
    state.buttonRoles = status
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
